<div fxLayout="column" style="height: 100vh" fxLayoutAlign="space-between start">
    <div fxLayout="column" class="w-100-p">
        <div
            class="navbar-header"
            [ngClass]="{ 'navbar-header--folded': folded }"
            fxLayout="row"
            [fxLayoutAlign]="folded ? 'center center' : 'space-between center'"
        >
            <img alt="site logo" [src]="siteLogo" class="logo" />
            <button
                mat-icon-button
                class="toggle-sidebar-folded icon-color-white ml-0"
                (click)="toggleSidebarFolded()"
                fxHide.lt-lg
                id="am-1359"
            >
                <mat-icon>menu</mat-icon>
            </button>

            <button
                mat-icon-button
                class="toggle-sidebar-opened icon-color-white"
                (click)="toggleSidebarOpened()"
                fxHide.gt-md
                id="am-1360"
            >
                <mat-icon>arrow_back</mat-icon>
            </button>
        </div>

        <div
            class="navbar-content"
            [ngClass]="{ 'folded-item': folded }"
            fusePerfectScrollbar
            [fusePerfectScrollbarOptions]="{ suppressScrollX: true }"
        >
            <fuse-navigation layout="vertical"></fuse-navigation>
        </div>
    </div>
    <div class="text-center w-100-p disable-text-color wrap-word p-4 mb-6">
        <span matTooltip="Front-end Version"> {{ buildVersion }}</span>
        <span matTooltip="Back-end Version" *ngIf="backendBuildVersion"> | {{ backendBuildVersion }}</span>
    </div>
</div>

<!-- Nav bar Top Menu -->
